import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  // useTheme,
} from "@mui/material";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { calculateAge } from "../../../../utilis/methods/dateMethods";
import { getPatientGroupingDisplay } from "../../../../utilis/methods/patientGrouping";
import { useFetchPatientDetailsByEMR } from "../../../hooks/apiHooks";
import DetailsSkeleton from "../../../../utilis/component/DetailsSkeleton";
import PatientVipChip from "../../../../utilis/component/PatientVipChip";
import useAuthentication from "@hooks/useAuthentication";
function PatientDetailsComponent() {
  const { encounterId } = useParams();
  // const theme = useTheme();
  const [searchParams] = useSearchParams();
  const emrNo = searchParams.get("emrno") || "";
  const {
    mutate: fetchDetails,
    data: patientData,
    isLoading,
  } = useFetchPatientDetailsByEMR({});

  useEffect(() => {
    fetchDetails({ encounterId: Number(encounterId || "0"), emrNo });
  }, []);
const {user} = useAuthentication()
const regionType = user?.region === "QATAR_REGION";

const viewerTitle = regionType
  ? "Qatar id"
  : "Emitrates id";
  return isLoading ? (
    <DetailsSkeleton variant="rounded"/>
  ) : (
    <div className="mx-2 mt-1">
      <Card
        sx={{
          borderRadius: 1,
          boxShadow: 2,
          backgroundColor: "background.paper",
        }}
      >
        <CardContent sx={{ padding: "16px" }}>
          <Grid container alignItems="center" spacing={2}>
            {/* Patient Information */}
            <Grid item xs>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                    Name
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Typography variant="body1" fontWeight="bold">
                      {patientData?.response?.pmaster?.patientName || ""}
                    </Typography>
                    <PatientVipChip
                      isVip={patientData?.response?.pmaster?.isVip}
                    />
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                    Doctor
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {patientData?.response?.encounter.doctorName || ""}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                      EMR No/Reg No
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {patientData?.response?.pmaster?.patientId || ""}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                    Department
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {patientData?.response?.encounter?.departmentName || ""}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                    Civil ID{" "}
                    {patientData?.response?.pmaster?.emiratesId &&
                     <span> ( {viewerTitle})</span>}
                    {patientData?.response?.pmaster?.passportNum &&
                      "( Passport number )"}
                    {patientData?.response?.pmaster?.gccId && "( GCC id )"}
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {patientData?.response?.pmaster?.emiratesId ||
                      patientData?.response?.pmaster?.passportNum ||
                      patientData?.response?.pmaster?.gccId ||
                      ""}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                    Age & Gender
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {
                      calculateAge(patientData?.response?.pmaster?.dob || "")
                        ?.age
                    }{" "}
                    {dobTypes[
                      calculateAge(patientData?.response?.pmaster?.dob || "")
                        ?.ageType
                    ] || ""}{" "}
                    {patientData?.response?.pmaster?.gender || ""}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="textSecondary">
                    Grouping
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {getPatientGroupingDisplay(patientData?.response) || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Avatar Section */}
            <Grid xs={2} item>
              <Avatar
                src={patientData?.response?.image || ""}
                variant="rounded"
                alt="Patient image"
                sx={{
                  width: 70,
                  height: 70,
                  fontSize: "1.2rem",
                  borderRadius: 4,
                }}
              >
                {`${String(patientData?.response?.pmaster?.patientName || "")[0] || ""} ${String(patientData?.response?.pmaster?.lastName || "")[0] || ""}`.toUpperCase()}
              </Avatar>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

export default PatientDetailsComponent;

const dobTypes = {
  Y: "Years",
  M: "Months",
  D: "Days",
};
